import { useEffect, useRef } from 'react';

/**
 * Lasciata la scheda di un torneo CONCLUSO, il torneo si archivia.
 *
 * Gemello di `useArenaResultsCleanup`, e nasce dallo stesso buco: lo store del
 * torneo non si azzerava mai: `onBack` della scheda non lo tocca, e `reset()`
 * aveva un solo chiamante, il logout. Cosi' `currentTournament` con il suo
 * `status: 'finished'`, la classifica finale, il vincitore e `isJoined`
 * restavano in canna per tutta la seduta, e non alimentavano soltanto la
 * navigazione: il banner della gara in corso, la domanda «c'e' una partita?» e
 * il ripiego di `doveTornareDopoIlRilascio` leggono tutti la' — l'uscita da una
 * partita online rilasciata, per esempio, scaricava nella lobby di un torneo
 * finito mezz'ora prima.
 *
 * La regola guarda dove si FINISCE, non da che porta si esce: l'elenco, la
 * home, il profilo o il gesto indietro sono la stessa cosa.
 *
 * ⚠️ Due schermate escluse, e sono la damiera e la sala d'attesa: li' la
 * partita vive SOLO nello store — `TournamentGame` travasa la posizione nello
 * stato locale, ma orologio, avversario e stanza no — e azzerarla lascerebbe una
 * damiera vuota che nessuno rimette.
 *
 * ⚠️ `tournament-detail` NON e' fra le esclusioni, e qui la differenza con
 * l'arena e' una proprieta' dello store, non una scelta: `reset()` del torneo
 * non incrementa nessuna generazione delle richieste (in `tournament-store.ts`
 * non ce n'e' una), quindi non annulla a meta' la `loadTournament` di un figlio
 * che si sta montando — che e' il caso per cui l'arena deve escludere il suo
 * dettaglio. E comunque da scheda a scheda `screen` non cambia, quindi la
 * guardia non scatta: aprire un secondo torneo non archivia il primo.
 *
 * E archivia il SOLO torneo finito: `tournamentStatus === 'finished'` e' parte
 * della regola. E' anche quello che tiene l'archiviazione dentro la seduta
 * VIVA — riaprendo lo stesso torneo dall'elenco `loadTournament` scrive
 * 'joined'/'viewing', quindi la guardia resta zitta — e la cintura che impedisce
 * di azzerare un torneo ancora in corso, che butterebbe fuori dal suo giro chi
 * lo sta giocando.
 */

/** Le schermate su cui `reset()` distruggerebbe stato che nessuno rimette. */
const SCHERMI_DA_NON_AZZERARE = ['tournament-lobby', 'tournament-game'];

export function useArchiviazioneTorneo(
  tournamentStatus: string,
  screen: string,
  reset: () => void,
): void {
  const precedente = useRef(screen);
  useEffect(() => {
    const prima = precedente.current;
    precedente.current = screen;
    if (
      prima === 'tournament-detail' &&
      screen !== 'tournament-detail' &&
      !SCHERMI_DA_NON_AZZERARE.includes(screen) &&
      tournamentStatus === 'finished'
    ) {
      reset();
    }
  }, [tournamentStatus, screen, reset]);
}
